import React, { useEffect } from 'react';
import proptypes from 'prop-types';
const { string, bool } = proptypes;
import classNames from 'classnames';

import { useImpression } from '@thd-olt-component-react/impression';

import {
  Button,
  Card,
  CardActions,
  CardBody,
  CardMedia,
  CardTitle,
  Typography
} from '@one-thd/sui-atomic-components';

const StoreWorkshopsComponent = ({ entryID, isCard, enableB2CRadius }) => {
  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('store-workshops.ready');
  }, []);

  const { ref, clickID } = useImpression({
    data: {
      id: entryID,
      name: 'StoreWorkshops',
      component: 'StoreWorkshops',
      position: 1,
      type: 'content',
    },
  });

  const CustomImg = () => (
    // eslint-disable-next-line @mizdra/layout-shift/require-size-attributes
    <img
      className={classNames('sui-object-cover sui-aspect-video sui-w-full', { '!sui-rounded-[12px]': enableB2CRadius })}
      alt="Kids Workshops"
      // eslint-disable-next-line max-len
      src="https://dam.thdstatic.com/content/production/yj3WJTXyW_sa2drCiZNoLQ/kanEAe6T97ZJ4ITd9g8RWw/Original%20file/08_2025_Kids_Workshop_Nov_BlackFridayBearOrnament_L.jpg?im=Crop,rect=(933.6211037745937,2163.999372746394,5517.551613291275,3102.521180138221);Resize=(703,395.44)"
    />
  );

  return (
    <Card
      ref={ref}
      clickid={clickID}
      className={classNames('sui-flex sui-justify-center sui-h-full', { '!sui-rounded-[12px]': enableB2CRadius })}
      data-component="StoreWorkshops"
    >
      <CardTitle
        header={(
          <Typography variant="h3">
            Free In-Store Kids Workshops
          </Typography>
        )}
      />
      <CardBody>
        <CardMedia component={CustomImg} />
        <div
          data-testid="card-content-wrapper"
          className={`${isCard ? 'store-workshop-card' : 'store-workshop-half'} sui-pb-4`}
        >
          <div className="sui-pt-4 sui-pb-2">
            <Typography
              component="h4"
              variant="body-lg"
              weight="bold"
            >
              Engaging Activities for Your Future Doers
            </Typography>
          </div>
          <Typography variant="body-base">
            Join us the first Saturday of every month, 9 a.m. - 12 noon. While supplies last.
          </Typography>
        </div>
        <CardActions>
          <Button href="/kids" variant="secondary" fullWidth>
            Register Now
          </Button>
        </CardActions>

      </CardBody>

    </Card>
  );
};

StoreWorkshopsComponent.displayName = 'StoreWorkshops';

export { StoreWorkshopsComponent };

StoreWorkshopsComponent.propTypes = {
  entryID: string,
  isCard: bool,
  enableB2CRadius: bool,
};

StoreWorkshopsComponent.defaultProps = {
  entryID: '',
  isCard: undefined,
  enableB2CRadius: false,
};
